import { featureFlagClient } from '@trello/feature-flag-client';
import {
  OrganizationFeature,
  OrganizationFeatures,
} from '@trello/product-features';
import { dontUpsell } from '@trello/config';
import getExperiment from 'app/scripts/lib/experiments/simple-test.coffee';

export function hasAdvancedChecklistsV2(orgProductNumber?: number) {
  return (
    featureFlagClient.get('remarkable.advanced-checklists-v2', false) &&
    !!orgProductNumber &&
    OrganizationFeatures.isFeatureEnabled(
      OrganizationFeature.AdvancedChecklists,
      orgProductNumber,
    )
  );
}

export function hasAdvancedChecklistsBeta(orgProductNumber?: number) {
  return (
    featureFlagClient.get('remarkable.advanced-checklists', false) &&
    !!orgProductNumber &&
    OrganizationFeatures.isFeatureEnabled(
      OrganizationFeature.AdvancedChecklists,
      orgProductNumber,
    ) &&
    // Ensure that only one of the `hasAdvancedChecklists___` functions returns `true`.
    !hasAdvancedChecklistsV2(orgProductNumber)
  );
}

export function hasUpsell() {
  return (
    featureFlagClient.get('remarkable.advanced-checklist-upsell', false) &&
    !dontUpsell &&
    (featureFlagClient.get('remarkable.advanced-checklists', false) ||
      featureFlagClient.get('remarkable.advanced-checklists-v2', false)) &&
    getExperiment('advancedChecklistUpsell').get('variation') === 'enabled'
  );
}

export function shouldShowEditModeButtons(orgProductNumber?: number) {
  return (
    (hasUpsell() || hasAdvancedChecklistsBeta(orgProductNumber)) &&
    // We won't be supporting the edit mode buttons in the v2 release.
    !featureFlagClient.get('remarkable.advanced-checklists-v2', false)
  );
}
